module.exports = __webpack_public_path__ + "static/media/SF-9-A.ddb2e21e.mp3";